import { Button, Grid, useDisclosure } from '@chakra-ui/react'
import type { InsuranceParamsPropertyDto, OfferProperty } from 'BrokerTsLib/src/dtos'
import { Product, Risk, RiskVariant } from 'BrokerTsLib/src/enums'

import type { SortBy } from '@/context/OffersProvider'
import { useApp } from '@/hooks/useApp'
import { useUrl } from '@/hooks/useInsuranceParams'
import { Container } from '../../components/Container'
import { Loading } from '../../components/Loading'
import { usePropertyOffersContext } from '../../context/PropertyOffersProvider'
import { baseUrl } from '../../hooks'
import { useUpdateInsuranceStartDate } from '../../hooks/useWizard'
import { Duplicate } from '../../icons'
import { useInsuranceParamsContext } from '../../layouts/Wizard'
import { NewInsuranceVariantWrapper } from '../chaloupka/NewInsuranceVariantWrapper'
import { ExtraInsurancePropertyModal } from '../ExtraInsurancePropertyModal'
import { FormButtons } from '../FormButtons'
import { OfferPropertyGrid } from './grid/OfferPropertyGrid'
import { OffersToolbar } from './OffersToolbar'

export const OfferPropertyCompare = ({ setOrderFunc }: {
  setOrderFunc?: (order: SortBy) => void
}) => {
  const { product } = useApp()

  const insuranceParamsUrl = useUrl()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useInsuranceParamsContext()
  const insuranceParamsProperty = insuranceParams as InsuranceParamsPropertyDto
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  const { offers, recalculateOffers, showAll, setShowAll, sortBy, setSortBy: changeSortBy, isLoading, updateOffer } = usePropertyOffersContext()
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)

  // seskupování podle domácnost / stavba / domácnost a stavba -> ne podle jednotlivých variant
  const variantsHoushold = insuranceParamsProperty.property.variants?.filter(v => v.variantParts && v.variantParts.some(vp => vp.risk == Risk.PROPERTY_TYPE) && v.variantParts.filter(vp => vp.risk == Risk.PROPERTY_TYPE).every(vp => vp.riskVariant == RiskVariant.Household))
  const variantsRealty = insuranceParamsProperty.property.variants?.filter(v => v.variantParts && v.variantParts.some(vp => vp.risk == Risk.PROPERTY_TYPE) && v.variantParts.filter(vp => vp.risk == Risk.PROPERTY_TYPE).every(vp => vp.riskVariant == RiskVariant.Realty))
  const variantsHousholdAndRealty = insuranceParamsProperty.property.variants?.filter(v => v.variantParts && v.variantParts.some(vp => vp.risk == Risk.PROPERTY_TYPE) && v.variantParts.filter(vp => vp.risk == Risk.PROPERTY_TYPE).every(vp => vp.riskVariant == RiskVariant.HouseholdAndRealty))
  const variantsResponsibility = insuranceParamsProperty.property.variants?.filter(v => v.variantParts && v.variantParts.some(vp => vp.risk == Risk.RESPONSIBILITY || vp.risk == Risk.RESPONSIBILITY_REALESTATE))

  const loadingOffers = (!offers || offers.length == 0) && isLoading

  return (
    <Grid sx={{ gap: 8 }}>
      <Container>
        <OffersToolbar
          offers={offers}
          editable={!insuranceParams?.generalParams.contractNumber}
          showAll={showAll}
          onSettingsClick={onOpen}
          setShowAll={setShowAll}
          onSetStartDate={(date: Date) => {
            return updateInsuranceStartDate(date)
              .then(() => {
                recalculateOffers()
                refetchInsuranceParams() // aby se updatnul header
              })
          }}
          sortBy={sortBy}
          changeSortBy={(sortBy) => {
            changeSortBy(sortBy)
            setOrderFunc?.(sortBy)
          }}
          updateOffer={(offer) => {
            console.log('updateOffer - OffersToolbar', offer.offerId, offer);
            updateOffer(offer as OfferProperty)
          }}
        />
      </Container>
      {loadingOffers && <Loading large={true} />}

      {!loadingOffers && variantsHoushold && variantsHoushold.length > 0 &&
        <OfferPropertyGrid variants={variantsHoushold} icon='household' />
      }

      {!loadingOffers && variantsRealty && variantsRealty.length > 0 &&
        <OfferPropertyGrid variants={variantsRealty} icon='property' />
      }

      {!loadingOffers && variantsHousholdAndRealty && variantsHousholdAndRealty.length > 0 &&
        <OfferPropertyGrid variants={variantsHousholdAndRealty} icon='householdProperty' />
      }

      {!loadingOffers && product == Product.LiabilityInsurance && variantsResponsibility && variantsResponsibility.length > 0 &&
        <OfferPropertyGrid variants={variantsResponsibility} icon='responsibility' />
      }

      {insuranceParams &&
        <>
          <Container>
            {!isContracted && <NewInsuranceVariantWrapper />}

            <FormButtons
              leftButtons={
                <Button variant="outline"
                  as='a'
                  href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(`${baseUrl}/chaloupka/wizard/1`)}`}
                >
                  <Duplicate color="secondary.500" />
                  Klonovat
                </Button>
              }
            />
          </Container>

          <ExtraInsurancePropertyModal isOpen={isOpen} onClose={onClose} />
        </>
      }

    </Grid>
  )
}
